import LecturerWorkloadSummaryModelBase from '../_generated/modelBases/lecturer-workload-summary-model-base';

export default class LecturerWorkloadSummaryModel extends LecturerWorkloadSummaryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
